export function DestinationsSection() {
    return (
      <section className="w-full px-4 py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-8">
            Despiértate con vistas al mar, a la montaña o dónde quieras
          </h2>
          
          <p className="text-xl max-w-3xl mx-auto mb-8">
            Furgos Río es descubrir paisajes únicos, conectar con la esencia de cada lugar y saborear cada instante. Es viajar sin prisas, siguiendo el ritmo que dicta tu corazón, compartiendo momentos inolvidables con quienes más quieres.
          </p>
    
          <a
            href="https://wa.me/34648728151"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-green-500 hover:bg-green-600 text-white px-8 py-3 rounded-lg text-lg"
          >
            Reserva por WhatsApp
          </a>
        </div>
      </section>
    );
  }